import { NgModule } from '@angular/core'
import { TRANSLOCO_CONFIG, TRANSLOCO_LOADER, TranslocoConfig, TranslocoModule } from '@ngneat/transloco'
import { TranslocoRootComponent } from './transloco-root.component'
import { TranslocoHttpLoader } from './transloco-http.loader'
import { CommonModule } from '@angular/common'
import { environment } from '../environments/environment'

const translocoConfig: TranslocoConfig = {
  availableLangs: ['cs'],
  defaultLang: 'cs',
  reRenderOnLangChange: false,
  prodMode: environment.production,
  missingHandler: {
    logMissingKey: false, // TODO: return
    useFallbackTranslation: false,
  },
}

@NgModule({
  declarations: [],
  imports: [CommonModule, TranslocoModule, TranslocoRootComponent],
  exports: [TranslocoRootComponent, TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig,
    },
    {
      provide: TRANSLOCO_LOADER,
      useClass: TranslocoHttpLoader,
    },
  ],
})
export class TranslocoRootModule {}